export const START_SUBSCRIBE = {
    action: 'START_SUBSCRIBE',
    label: 'Start Subscription',
};

export const CHOOSE_SCHEDULE = {
    action: 'CHOOSE_SCHEDULE',
    label: 'Choose Schedule',
};

export const CHOOSE_CALENDAR = {
    action: 'CHOOSE_CALENDAR',
    label: 'Choose Calendar',
};

export const ENTER_DETAILS = {
    action: 'ENTER_DETAILS',
    label: 'Enter details',
};

export const SEND_TO_PHONE = {
    action: 'SEND_TO_PHONE',
    label: 'Send to phone',
};

export const SUBSCRIBE_COMPLETE = {
    action: 'SUBSCRIBE_COMPLETE',
    label: 'Subscription completed',
};

export const SHARE = {
    action: 'SHARE',
    label: 'Share button click',
};

export const CALENDAR_NOT_FOUND = {
    action: 'CALENDAR_NOT_FOUND',
    label: 'Calendar ID, Reference, or Category provided by Publisher not found in ECAL',
};

export const CATEGORY = 'PUBLISHER_NAME';
 
export const ERROR_OCCURRED = {
    action: 'ERROR_OCCURRED',
    label: 'Oops, something went wrong message displayed',
};

export const ALMOST_DONE_PROC = {
    action: 'ALMOST_DONE',
    label: 'ICS instructions'
};

export const ALMOST_DONE_PROC_TIMEOUT = {
    action: 'ALMOST_DONE_TIMEOUT',
    label: 'ICS instructions'
};

export const NEW_OUTLOOK_CALENDAR = {
    action: 'NEW_OUTLOOK_CALENDAR',
    label: 'New Outlook Calendar'
};
  